import React, { FC, useContext } from 'react';
import { ContextApi } from 'react-uforms';
import { Col, Row } from 'styled-bootstrap-grid';
import { FormError } from '@ch/common/components/form/error';
import { Box } from '@ch/common/components/box';
import { FormRadioIcon, FormRadioInput, FormRadioLabel } from '@ch/common/components/form/radio';
import { Text } from '@ch/common/components/text';
import { Heading } from '@ch/common/components/heading';
import { Question } from '@ch/common/types/data';
import { QuizFieldPersonStyled, QuizPersonBlock, QuizPersonBlockImg } from './quiz.styled';
import { assetsPath } from '../const';
import { fieldGroups } from './types';
import { QuizContext } from './quiz-context';

const QuizFieldPerson: FC<Question> = ({ identifier: id, options = [] }) => {
  const { getValue, setGroupActive } = useContext(ContextApi);
  const { token } = useContext(QuizContext);

  return (
    <QuizFieldPersonStyled>
      <Row>
        {options?.map(({ identifier, option, information, image, altText }) => (
          <Col md={4} key={identifier}>
            <QuizPersonBlock
              $p={[15]}
              $mb={15}
              as="label"
              $display="block"
              $bgColor={getValue(id) === identifier ? 'primaryLighter' : 'white'}
            >
              <Box $m={[0, 0, 15]}>
                <QuizPersonBlockImg
                  {...{ alt: altText, title: option, src: `${assetsPath}/${image}`, $disabled: !token }}
                />
              </Box>
              <Box $display="flex" $alignItems="flex-start">
                <Box $m={[4, 0, 0, 2]}>
                  <FormRadioInput
                    {...{
                      name: id,
                      value: identifier,
                      disabled: !token,
                      onChange: () => {
                        window?.scrollTo(0, 0);
                        setGroupActive(fieldGroups.FORM);
                      },
                    }}
                  />
                  <FormRadioLabel>
                    <FormRadioIcon />
                  </FormRadioLabel>
                </Box>
                <div>
                  <Heading
                    $m={[0, 0, 8]}
                    as="h3"
                    $size="h3"
                    $color={token ? 'primary' : 'grayMedium'}
                    $fontFamily="aeonikBold"
                  >
                    {option}
                  </Heading>
                  <Text $m={[0]} $color={token ? 'primary' : 'grayLighter'}>
                    {information}
                  </Text>
                </div>
              </Box>
            </QuizPersonBlock>
          </Col>
        ))}
      </Row>
      <FormError name={id} />
    </QuizFieldPersonStyled>
  );
};

export default QuizFieldPerson;
